import { createSelector } from '@reduxjs/toolkit';

export const breadcrumbsSelector = (state: ReduxState) => state.breadcrumbsReducer;
export const selectAdditionalParams = createSelector(
    breadcrumbsSelector,
    (breadcrumbs) => breadcrumbs?.additionalParams
);
